import React, { Component } from 'react';
import { NavLink } from "react-router-dom";

import config from './../config';
import EntryView from './EntryView';

class PageMenu extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/pages/';

		this.state = {
			listData: []
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {
		// Sæki gögn til APA
		this.setState({
			listData: []
		});

		fetch(this.url)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results
				});
			}.bind(this));
	}

	render() {
		return (
			<React.Fragment>
				{
					this.state.listData.map(function(item, index) {
						return <NavLink key={index} to={'/s/'+item.id}>{item.title}</NavLink>;
					})
				}
			</React.Fragment>
		);
	}
}

export default PageMenu;



// WEBPACK FOOTER //
// ./src/components/PageMenu.js